import styled from 'styled-components';
import { hexToRgba } from '@/main/services/utils';

const opacitybackground = (percent: number) => {
  if (percent < 0.5) return 0.5;
  if (percent < 0.7) return 0.75;
  return 1;
};
const sizePercentage = (percent: number, percentFormatted: string) => {
  if (percent < 0.2) return '18%';

  return percentFormatted;
};
export const Container = styled.div`
  width: 100%;
  max-width: 300px;
`;
export const ContainerPercentage = styled.div`
  height: 30px;
  width: 100%;
  border-radius: 12px;
  /* background: ${({ theme }) => theme.pantone2726C}; */
  border: 1px solid ${({ theme }) => theme.grayDarker};
`;

interface IPercentageProps {
  $numberPercentage: string; // 50%
  $decimalPercentage: number; // 0.5
}
export const Percentage = styled.div<IPercentageProps>`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  background: ${({ theme, $decimalPercentage }) =>
    hexToRgba(theme.pantone2726C, opacitybackground($decimalPercentage))};
  color: ${({ theme }) => theme.white};
  border-radius: inherit;
  height: 100%;
  width: ${({ $numberPercentage, $decimalPercentage }) =>
    sizePercentage($decimalPercentage, $numberPercentage)};
  padding: 0 0.4rem 0 0;
`;

